import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { useSnackbarManager } from '../../utils/providers/snackbarContext'
import { useSidebarContext } from '../../utils/providers/sidebarContext'

export const useAfterArchiveEntity = (): ((path: string, archive: () => Promise<unknown>) => Promise<void>) => {
  const navigate = useNavigate()
  const { reloadItems } = useSidebarContext()
  const [, setSnackbar] = useSnackbarManager()
  const t = useAppTranslations()

  return useCallback(
    async (path: string, archive: () => Promise<unknown>) => {
      await archive()
      setSnackbar({ severity: 'success', message: t('commons.saved') })
      reloadItems()
      navigate(path)
    },
    [navigate, reloadItems, setSnackbar, t]
  )
}
